<template>
  <v-card>
    <v-card-text class="align-text-center pt-5">
      <v-img :src="applicationLogoUrl" max-width="250" class="mx-auto" />
      <h2 class="my-6">
        <b>Your session has expired</b>
      </h2>

      <p class="text-center mx-7 mb-6">Please log in to continue using {{ applicationName }}.</p>

      <v-btn depressed color="brand" width="140" class="mx-2 white--text" @click="refreshPage"
        >Log In</v-btn
      >
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import whitelabelMixin from "@/mixins/whitelabelMixin";

export default {
  name: "MagicLinkExpirationPopup",
  components: {},
  mixins: [whitelabelMixin],
  props: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {
    refreshPage() {
      // this.$store.dispatch("setMagicLinkTokenExpirationWarning", false);
      document.location.reload();
    },
  },
  computed: {
    ...mapState([]),
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
